import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchBrushes = (category) =>
  api.get("/brushes", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);

export const fetchBrush = (id) => api.get(`/brushes/${id}`).then((r) => r.data);

export const submitQuiz = (answers) => api.post("/quiz", answers).then((r) => r.data);

export const sendChat = (payload) => api.post("/chat", payload).then((r) => r.data);

export const fetchShopProducts = () => api.get("/shop/products").then((r) => r.data);

export const fetchCartSummary = (items) =>
  api.post("/shop/cart/summary", items).then((r) => r.data);

export const createCheckoutSession = (payload) =>
  api.post("/shop/checkout", payload).then((r) => r.data);

export const fetchCheckoutStatus = (sessionId) =>
  api.get(`/shop/checkout/status/${sessionId}`).then((r) => r.data);
